import React from "react";
import { OptiCommonHeader } from "../../components/OptiCommonHeader/OptiCommonHeader";
import { Error404 } from "./Error404";

export const NotFound = () => {
    return (
        <>
            <OptiCommonHeader />
            <Error404 />
        </>
    );
};

NotFound.displayName = "NotFound";
